import { useEffect } from 'react';

/**
 * Shared body scroll lock with reference counting.
 * Multiple components can lock simultaneously; the body only unlocks
 * when the last consumer releases its lock.
 */
let lockCount = 0;
let savedOverflow = '';
let savedPaddingRight = '';

function lock() {
    if (lockCount === 0) {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        savedOverflow = document.body.style.overflow;
        savedPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
    lockCount++;
}

function unlock() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
        document.body.style.overflow = savedOverflow;
        document.body.style.paddingRight = savedPaddingRight;
    }
}

/**
 * Hook to lock body scroll while active is truthy.
 * @param {boolean} active - Whether the scroll lock should be engaged
 */
export function useBodyScrollLock(active) {
    useEffect(() => {
        if (!active) return;
        lock();
        return () => unlock();
    }, [active]);
}
